import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalContainerComponent } from './modal-container.component';
import { ModalDirective } from './modal.directive';
import { ModalService } from './modal.service';
import { TranslateModule } from '@ngx-translate/core';
import { FocusService } from '../../services/focus.service';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild()
    ],
    declarations: [
        ModalContainerComponent,
        ModalDirective
    ],
    exports: [
        ModalDirective
    ],
    providers: [
        ModalService,
        FocusService
    ]
})
export class ModalModule {
}
